import type { OfferWrapper } from 'generated/api'
import { Ribbon } from './Ribbon'
import { useOfferRedirect } from 'shared/ResultsProvider'
import { Button, Card, Text, View } from 'reshaped/bundle'
import { ThumborImg } from '../../../../lib/images/ThumborImg'
import { dangerouslySetHTML } from './SimpleOffer.css'

interface Props {
	offer: OfferWrapper
}

export const SimpleOffer = ({ offer }: Props) => {
	const redirect = useOfferRedirect()
	const onClick = () => redirect(offer)
	const trivia = offer.trivia[0]

	return (
		<Card elevated padding={0}>
			<Ribbon categoryDetails={offer.categoryDetails} display={offer.display} />
			<View direction={{ s: 'column', l: 'row' }} padding={4} gap={{ s: 2, l: 6 }}>
				<View>
					<ThumborImg
						src={offer.image}
						alt={offer.provider}
						options={{ width: 110, height: 30 }}
						style={{ width: '110px', height: '30px', objectFit: 'contain', objectPosition: 'left' }}
					/>
				</View>
				<View.Item grow>
					<View direction="column" gap={1}>
						<Text variant="featured-3" weight="bold" color="neutral">
							{trivia.title}
						</Text>
						<Text
							variant="body-2"
							color="neutral-faded"
							className={dangerouslySetHTML}
							attributes={{ dangerouslySetInnerHTML: { __html: trivia.value } }}
						/>
					</View>
				</View.Item>
				<View>
					<Button color="positive" size="large" onClick={onClick} fullWidth={{ s: true, l: false }}>
						Continue
					</Button>
				</View>
			</View>
		</Card>
	)
}
